import React, { useEffect, useState } from 'react';
import UnassignedAssignment from './components/UnassignedAssignment';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { connectLean } from 'lean-redux';
import { compose } from 'react-apollo';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import PracticeProblems from './PracticeProblems';
import {
  getAssignmentsForResource,
  renderAssessmentProgress,
} from 'legacy-packages/unit-outline/src/components/_shared/util';
import { SEARCH_RESOURCE_TYPES_MAP } from 'chameleon-src/components/ResourceSearch/utils/constants';
import get from 'lodash/get';
import { formatUpdatedAssignment } from 'chameleon/ui-stack/ui/units/subunit-content/ppc';

const getUnitResources = (unitsState, unitId) =>
  (unitsState[`unit-${unitId}`] || {}).resources || {};

const TeacherPracticeProblems = (props) => {
  const {
    resources = [],
    subjectData,
    unitId,
    unitNumber,
    unitTitle,
    userData,
    router,
    showRightContent = true,
    showResourceContent = true,
    unitsState,
    assignments: teacherAssignments,
    params: { subject },
    assessmentDataCache,
  } = props;
  let assignments = [...teacherAssignments];

  const subunitType = SEARCH_RESOURCE_TYPES_MAP['practice-problems'];
  const subjectId = typeof subjectData === 'object' ? subjectData.id : subject;
  const { location } = router || {};
  const { areAssignmentStatusesLoaded } = unitsState;
  const [isLoading, setIsLoading] = useState(true);
  const [resourceStatuses, setResourceStatuses] = useState({});

  const { isAdmin, isCoordinator, isTeacher } = userData;
  const isAdminOrCoordinator = isAdmin || isCoordinator;

  useEffect(() => {
    if (areAssignmentStatusesLoaded) {
      setResourceStatuses(getUnitResources(unitsState, unitId));
      setIsLoading(false);
    }
  }, [areAssignmentStatusesLoaded]);

  useEffect(() => {
    if (areAssignmentStatusesLoaded) {
      setResourceStatuses(getUnitResources(unitsState, unitId));
    }
  }, [unitsState]);

  const createAssessmentProgressComponent = (
    isSPPAssigned,
    assignmentsForResource,
    displayName,
    resource,
    scope,
  ) =>
    renderAssessmentProgress(
      isSPPAssigned,
      assignmentsForResource,
      displayName,
      resource,
      isAdminOrCoordinator,
      subjectId,
      false,
      false,
      assignments,
      scope,
      subunitType,
    );

  const getSppResourceAction = (resource) => {
    const { assessmentId } = resource;
    const assessmentResourceStatusKey = Object.keys(resourceStatuses).find(
      (resourceStatusKey) =>
        resourceStatuses[resourceStatusKey].assessmentId === assessmentId,
    );
    const connectLeanResourceScope = [
      'units',
      `unit-${unitId}`,
      'resources',
      assessmentResourceStatusKey,
    ];

    const { sppAssignments, assignResponses = [] } =
      resourceStatuses[assessmentResourceStatusKey] || {};

    if (assignResponses.length > 0) {
      let recentUpdatedAssignment = [];
      recentUpdatedAssignment = formatUpdatedAssignment(
        subjectData.classes,
        assignResponses,
        // assessment dataCache to get question information for this assessment
        assessmentDataCache[resource.assessmentId],
      );
      assignments = assignments.concat(recentUpdatedAssignment);
    }

    const assignmentsForResource = getAssignmentsForResource({
      assignments,
      resource,
      updatedAssignments: get(sppAssignments, assessmentId, []),
    });

    const isSPPAssigned = (assignmentsForResource || []).length > 0;

    const assessmentProgressComponent = createAssessmentProgressComponent(
      isSPPAssigned,
      assignmentsForResource,
      resource.displayName,
      resource,
      connectLeanResourceScope,
    );

    const assignProps = {
      resource,
      unitNumber,
      assessmentId,
      unitTitle,
      isTeacher,
      router,
      subjectId,
      scope: connectLeanResourceScope,
      isAdminOrCoordinator,
    };

    if (assessmentProgressComponent) {
      return assessmentProgressComponent;
    }
    return <UnassignedAssignment {...assignProps} />;
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  const previewUrl = (itemId) =>
    `/${subject}/assessments/spp/preview/${itemId}`;

  const onResourceClicked = (url) =>
    router.push({
      pathname: url,
      state: {
        returnPath: `${location.pathname}${location.search}`,
      },
    });

  return (
    <PracticeProblems
      resources={resources}
      showResourceContent={showResourceContent}
      getResourceActions={getSppResourceAction}
      showRightContent={showRightContent}
      onTitleClicked={(event, resource, assessmentId) => {
        onResourceClicked(previewUrl(assessmentId));
      }}
    />
  );
};

TeacherPracticeProblems.displayName = 'TeacherPracticeProblems';

const mapStateToProps = ({ subject, userData, assessmentDataCache }) => {
  return {
    subjectData: subject.data,
    userData,
    assessmentDataCache,
  };
};
export default compose(
  connectLean({
    scope: 'units',
    mapState: (state) => ({
      unitsState: state,
    }),
  }),
  connect(mapStateToProps),
)(withRouter(TeacherPracticeProblems));
